import {InputText} from '@/components/Form/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBms} from '../BM/FormChooseBm.jsx'
import {FormItemPms} from '../PM/FormChoosePm.jsx'
import Model from './ModelBf.mjs'

export const FormItemBfName = props => (
    <FormItemBizProp
        Model={Model}
        prop="bfName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemBfNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="bfNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseBf(props) {
    const map = useMapContext()
    const {prjTypeCode, subTypeCode} = map.data

    return (
        <FormChooseDesign {...props}>
            {
                (
                    'BM' === prjTypeCode ||
                    'BODA2' === subTypeCode
                ) ? <FormItemPms /> : <FormItemBms />
            }

            <FormItemBfNo />
            <FormItemBfName />
        </FormChooseDesign>
    )
}
